/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ApiKey
 */
export interface ApiKey {
  /**
   *
   * @type {string}
   * @memberof ApiKey
   */
  apiKeyId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiKey
   */
  keyHash?: string;
  /**
   *
   * @type {string}
   * @memberof ApiKey
   */
  keyPrefix?: string;
  /**
   *
   * @type {string}
   * @memberof ApiKey
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof ApiKey
   */
  description?: string;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof ApiKey
   */
  createdAt?: OffsetDateTime;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof ApiKey
   */
  lastUsedAt?: OffsetDateTime;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof ApiKey
   */
  expiresAt?: OffsetDateTime;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof ApiKey
   */
  revokedAt?: OffsetDateTime;
  /**
   *
   * @type {string}
   * @memberof ApiKey
   */
  createdByUserId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiKey
   */
  createdByEmail?: string;
  /**
   *
   * @type {string}
   * @memberof ApiKey
   */
  companyId?: string;
  /**
   *
   * @type {boolean}
   * @memberof ApiKey
   */
  isActive?: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiKey
   */
  createdByAdminEmail?: string;
  /**
   *
   * @type {string}
   * @memberof ApiKey
   */
  revokedBy?: string;
  /**
   *
   * @type {string}
   * @memberof ApiKey
   */
  revokeReason?: string;
}

/**
 * Check if a given object implements the ApiKey interface.
 */
export function instanceOfApiKey(value: object): value is ApiKey {
  return true;
}

export function ApiKeyFromJSON(json: any): ApiKey {
  return ApiKeyFromJSONTyped(json, false);
}

export function ApiKeyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ApiKey {
  if (json == null) {
    return json;
  }
  return {
    apiKeyId: json["apiKeyId"] == null ? undefined : json["apiKeyId"],
    keyHash: json["keyHash"] == null ? undefined : json["keyHash"],
    keyPrefix: json["keyPrefix"] == null ? undefined : json["keyPrefix"],
    name: json["name"] == null ? undefined : json["name"],
    description: json["description"] == null ? undefined : json["description"],
    createdAt: json["createdAt"] == null ? undefined : json["createdAt"],
    lastUsedAt: json["lastUsedAt"] == null ? undefined : json["lastUsedAt"],
    expiresAt: json["expiresAt"] == null ? undefined : json["expiresAt"],
    revokedAt: json["revokedAt"] == null ? undefined : json["revokedAt"],
    createdByUserId:
      json["createdByUserId"] == null ? undefined : json["createdByUserId"],
    createdByEmail:
      json["createdByEmail"] == null ? undefined : json["createdByEmail"],
    companyId: json["companyId"] == null ? undefined : json["companyId"],
    isActive: json["isActive"] == null ? undefined : json["isActive"],
    createdByAdminEmail:
      json["createdByAdminEmail"] == null
        ? undefined
        : json["createdByAdminEmail"],
    revokedBy: json["revokedBy"] == null ? undefined : json["revokedBy"],
    revokeReason:
      json["revokeReason"] == null ? undefined : json["revokeReason"],
  };
}

export function ApiKeyToJSON(json: any): ApiKey {
  return ApiKeyToJSONTyped(json, false);
}

export function ApiKeyToJSONTyped(
  value?: ApiKey | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    apiKeyId: value["apiKeyId"],
    keyHash: value["keyHash"],
    keyPrefix: value["keyPrefix"],
    name: value["name"],
    description: value["description"],
    createdAt: value["createdAt"],
    lastUsedAt: value["lastUsedAt"],
    expiresAt: value["expiresAt"],
    revokedAt: value["revokedAt"],
    createdByUserId: value["createdByUserId"],
    createdByEmail: value["createdByEmail"],
    companyId: value["companyId"],
    isActive: value["isActive"],
    createdByAdminEmail: value["createdByAdminEmail"],
    revokedBy: value["revokedBy"],
    revokeReason: value["revokeReason"],
  };
}
